<template>
  <div
    ref="wrap"
    v-show="value"
    @mousedown="clickDownHandle"
    @mouseup="unbindEvents"
    class="draggable-dialog"
  >
    <button
      style="
        padding: 5px;
        outline: none;
        position: absolute;
        right: 0;
        z-index: 1;
        margin-right: 10px;
        margin-top: 10px;
      "
      @click="onClose"
    >
      <svg
        height="10"
        viewBox="0 0 365.696 365.696"
        width="10"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="m243.1875 182.859375 113.132812-113.132813c12.5-12.5 12.5-32.765624 0-45.246093l-15.082031-15.082031c-12.503906-12.503907-32.769531-12.503907-45.25 0l-113.128906 113.128906-113.132813-113.152344c-12.5-12.5-32.765624-12.5-45.246093 0l-15.105469 15.082031c-12.5 12.503907-12.5 32.769531 0 45.25l113.152344 113.152344-113.128906 113.128906c-12.503907 12.503907-12.503907 32.769531 0 45.25l15.082031 15.082031c12.5 12.5 32.765625 12.5 45.246093 0l113.132813-113.132812 113.128906 113.132812c12.503907 12.5 32.769531 12.5 45.25 0l15.082031-15.082031c12.5-12.503906 12.5-32.769531 0-45.25zm0 0"
        />
      </svg>
    </button>
    <slot></slot>
  </div>
</template>

<script>
import "./draggable-dialog.scss";

let targetElement = {
  startX: 0,
  startY: 0,
  offsetLeft: 0,
  offsetTop: 0,
  zIndex: 5,
};

export default {
  props: {
    value: {
      type: Boolean,
    },
    initialPosition: {
      top: 0,
      left: 0,
    },
  },
  data() {
    return {
      observer: null,
    };
  },
  methods: {
    onClose() {
      this.$emit("input", false);
      this.$emit("onClosed");
    },
    clickDownHandle({ clientX, clientY }) {
      const { wrap } = this.$refs;
      wrap.style.zIndex = targetElement.zIndex;
      targetElement = {
        startX: clientX,
        startY: clientY,
        offsetLeft: clientX - wrap.offsetLeft,
        offsetTop: clientY - wrap.offsetTop,
        zIndex: targetElement.zIndex + 1,
      };

      this.bindEvents();
    },
    startMoveHandle({ clientX, clientY }) {
      const { offsetLeft, offsetTop } = targetElement;
      const { wrap } = this.$refs;
      wrap.style.left = clientX - offsetLeft + "px";
      wrap.style.top = clientY - offsetTop + "px";
    },
    endMoveHandle() {
      this.unbindEvents();
    },
    unbindEvents() {
      document.removeEventListener("mousemove", this.startMoveHandle);
      document.removeEventListener("mouseup", this.endMoveHandle);
    },
    bindEvents() {
      document.addEventListener("mousemove", this.startMoveHandle, {
        passive: true,
      });
      document.addEventListener("mouseup", this.endMoveHandle);
    },
    open({ left = 0, top = 0 }) {
      this.$emit("input", true);
      const { wrap } = this.$refs;
      wrap.style.left = left + "px";
      wrap.style.top = top + "px";
    },
    // This function is used outside of this component
    incrementZIndex() {
      const { wrap } = this.$refs;
      wrap.style.zIndex = targetElement.zIndex;
      targetElement.zIndex += 1;
    },
    setStyle({ el, zIndex }) {
      el.style.left = "40vw";
      el.style.top = "20vh";
      el.style.zIndex = zIndex;
    },
  },
  computed: {},
  mounted() {
    const { wrap } = this.$refs;
    const { top, left } = this.initialPosition;
    this.setStyle({ el: wrap, top, left, zIndex: targetElement.zIndex });
    targetElement.zIndex++;
  },
  created() {},
};
</script>
